import { MappingProblemSolutionStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const mappingProblemSolutionStatusDictionary = createSimpleDictionary([
    { id: MappingProblemSolutionStatus.Proposed, name: 'dictionaries.mappingProblemSolutionStatus.proposed' },
    { id: MappingProblemSolutionStatus.Applied, name: 'dictionaries.mappingProblemSolutionStatus.applied' },
]);
